import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { addFixatgeAsync } from '../../actions/controlPresenciaActions';
import { FormulariIncidencia } from '../Incidencia/FormulariIncidencia';
import { crearTotOkAction, uiAmagarDiaConsultatAction, uiAmagarIncidenciesAction, uiMostraIncidenciesAction } from '../../actions/ui';

// CORRECCIÓ: afegit estat local `enviant` per desactivar el botó durant la petició
// i evitar el doble submit que causava 2 fixatges de sortida a la mateixa hora.

export const FormulariFiJornada = () => {
  const dispatch = useDispatch();
  const [radioTipusControlPresencia, setRadioTipusControlPresencia] = useState('');
  const [enviant, setEnviant] = useState(false);
  const { t, i18n } = useTranslation('generic');

  const { auth, configUsuari, ui } = useSelector(
    state => ({
      auth: state.auth,
      configUsuari: state.configUsuari,
      ui: state.ui
    }),
    shallowEqual
  );

  const { incidencia, diaConsultat } = ui;

  const handleChange = useCallback((e) => {
    setRadioTipusControlPresencia(e.target.value);
  }, []);

  const handleChangeIncidencia = useCallback(() => {
    if (incidencia) {
      dispatch(uiAmagarIncidenciesAction());
    } else {
      dispatch(uiMostraIncidenciesAction());
      dispatch(uiAmagarDiaConsultatAction());
    }
  }, [dispatch, incidencia]);

  const enviarControlPresenciaEntrada = useCallback((e) => {
    e.preventDefault();

    if (!radioTipusControlPresencia) {
      dispatch(crearTotOkAction(t('FormulariFiIniciJornada.msgOkNoSelec')));
      return;
    }

    // Bloquejar immediatament per evitar doble submit
    if (enviant) return;
    setEnviant(true);

    dispatch(
      addFixatgeAsync(
        radioTipusControlPresencia,
        auth.tokenJwt,
        i18n.language,
        configUsuari?.contingut?.saltaUrlPortalComb
      )
    ).finally(() => {
      setEnviant(false);
    });

  }, [radioTipusControlPresencia, enviant, dispatch, auth.tokenJwt, i18n.language, configUsuari, t]);

  return (
    <>
      <div className="row">
        {[
          { id: 'tipusRegistreInicial_FiJornada', value: 3, label: t('FormulariFiIniciJornada.fiJornada') },
          { id: 'tipusRegistreInicial_Dinar',     value: 4, label: t('FormulariFiIniciJornada.dinar') }
        ].map(radio => (
          <div key={radio.id} className={`col-md-4 ${radio.value === 3 ? 'offset-md-3' : ''}`}>
            <div className="form-check mb-3">
              <input
                type="radio"
                id={radio.id}
                className="form-check-input"
                name="tipusRegistreSortida"
                value={radio.value}
                onChange={handleChange}
                disabled={enviant}
              />
              <label className="form-check-label" htmlFor={radio.id}>
                {radio.label}
              </label>
            </div>
          </div>
        ))}
      </div>

      <div className="mb-3 text-center">
        <button
          type="button"
          onClick={enviarControlPresenciaEntrada}
          className="btn btn-primary btn-sm m-1"
          disabled={enviant}
        >
          {enviant
            ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>{t('Generics.enviant') || 'Enviant...'}</>
            : t('FormulariFiIniciJornada.enviar')
          }
        </button>
      </div>

      <div className="row">
        <p>
          {t('FormulariFiIniciJornada.PregIncidencia')}{' '}
          <button
            type="button"
            onClick={handleChangeIncidencia}
            className="btn btn-outline-primary btn-sm m-1 col-md-4"
            disabled={enviant}
          >
            {t('FormulariFiIniciJornada.incidencia')}
          </button>
        </p>
        {incidencia && !diaConsultat && <FormulariIncidencia />}
      </div>
    </>
  );
};

export default React.memo(FormulariFiJornada);